export default __webpack_public_path__ + "static/B0109-971cbff9151d736229076b7d38d76c0f.png";